<template>
    <user-layout
        hasBack
        backLink="/office/index"
    >
        <div class="max-w-[500px] mx-auto py-6"  v-if="loaded">
            <form-section
                v-if="!loading"
                :form="form"
                :errors="errors"
                :regionOptions="regionOptions"
                :provinceOptions="provinceOptions"
                :cityOptions="cityOptions"
                :barangayOptions="barangayOptions"
                @update:location="init()"
            >
                <div class="col-span-2">
                    <div class="flex items-center justify-end w-full space-x-3">
                        <a href="/office/index/">
                            <button-component
                                btnWidth="quinary"
                            >Cancel</button-component>
                        </a>

                        <button-component
                            v-if="canUpdate()"
                            btnWidth="primary"
                            @click="showConfirmation = true"
                        >Save Changes</button-component>
                    </div>
                    <confirmation-modal
                        :typeTwo="true"
                        :show="showConfirmation"
                        @cancel="showConfirmation = false"
                        @confirm="save()"
                        cancel-text="Cancel"
                        action-text="Confirm"
                        title="Save Record"
                        content="Are you sure you wish to save this record?"
                    />
                    <success-modal
                        :show="showSuccess"
                        @confirm="showSuccess = false, $router.replace('/office/index')"
                        action-text="Close"
                        title="Succes!"
                       :content="successMessage"
                    />
                </div>
            </form-section>
        </div>
        <error-modal :show="showError" :content="showErrorMessage" />
        <page-loader :show="loading"/>
    </user-layout>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PageLoader from "@/components/loaders/PageLoader.vue"
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';
import ErrorModal from "@/components/modals/ErrorModal.vue";
import { errorResponse } from "@/helpers/errorMessage";

import Offices from "@/classes/Offices";
import {
    OfficeUpdateDataInterface,
    SelectInterface
} from "@/interfaces/pages/offices/OfficeInterface"

import pickBy from "lodash/pickBy";

import assignValues from "@/helpers/assignValues"
import { hasPermission } from "@/classes/AuthService";
import { useRoute, useRouter } from "vue-router";
import Storage from "@/helpers/storage";
import { RoleTypes } from '../enums/RoleTypes';

const route = useRoute();
const router = useRouter();

const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loaded = ref<boolean>(false);
const successMessage = ref<string>('');
const errors = ref<any>();

const form = ref<OfficeUpdateDataInterface>({
    id: parseInt(route.params.office),
    name: '',
    prefix: '',
    contact_number: '',
    address: '',
    region_id: 0,
    province_id: 0,
    city_id: 0,
    barangay_id: 0,
    status: 1,
    encoded_by: 0,
    file_url: null,
    iso_intake: '',
    iso_scar: '',
    iso_assessment: '',
    iso_patient_profile: '', 
});

const regionOptions = ref<SelectInterface[]>([]);
const provinceOptions = ref<SelectInterface[]>([]);
const cityOptions = ref<SelectInterface[]>([]);
const barangayOptions = ref<SelectInterface[]>([]);
const showError = ref(false);
const showErrorMessage = ref(null);
const tokens = new Storage();
const user = JSON.parse(tokens.get("user"));

const init = (): void => {
    loading.value = true; 

    Offices.edit(form.value.id, pickBy(form.value))
        .then(({ data }) => { 
            form.value = assignValues(form.value, data.item);
            loading.value = false;
            loaded.value = true;
        })
}

const save = (): void => {
    loading.value = true; 

    Offices.update(form.value.id, form.value)
        .then((response: any) => {
            loading.value = false;
            successMessage.value = response.data.message;
            showSuccess.value = true;
            showConfirmation.value = false
        })
        .catch((error: any) => {
            loading.value = false;
            showConfirmation.value = false
            errors.value = errorResponse(error.response?.data?.errors)
            showError.value = true;
            showErrorMessage.value = 'Please fill up all required fields/Error Saving';
        });
}

const canUpdate = () => {
    if (user.role_id == RoleTypes.SUPERADMIN || user.role_id == RoleTypes.SUPERADMIN_IT) {
        return true;
    }

    return false;
}

onMounted(() => {
    init()
});

</script>